import { Button, Container, Layout, Spacer, Text, Tooltip } from '@loomhq/lens';
import classnames from 'classnames';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import salesforceIcon from 'img/logos/salesforce.svg';

import SalesforceEmailsList from './salesforce-email-list';
import { updateSalesforceModal } from '../../../actions/shareVideo';
import { getShareVideoAlias } from '../../../creators/shareVideo';
import { useFeatureFlagValue } from '../../../hooks/featureFlag';
import { useIntegrationList } from '../../../hooks/integrations';
import { ROLLOUT_INTEGRATIONS_LISTING } from '../../../../../shared/constants/featureFlag';
import {
  VIDEO_PRIVACY_OWNER,
  VIDEO_PRIVACY_WORKSPACE,
} from '../../../../../shared/constants/video';

import styles from './styles.module.less';

const SalesforceShare = () => {
  const dispatch = useDispatch();
  const { video, shareVideoAliases } = useSelector(state => state.share_video);
  const hasFeatureFlag = useFeatureFlagValue(ROLLOUT_INTEGRATIONS_LISTING);
  const showModal = () => dispatch(updateSalesforceModal(true));

  const { selectedWorkspace } = useSelector(state => state.workspace);

  const { integrationList } = useIntegrationList({
    organization_id: selectedWorkspace?.id,
  });

  const sfdcIntegration = integrationList.find(
    ({ type, IntegrationSubscriptions }) => {
      return (
        type === 'SFDC' && IntegrationSubscriptions[0]?.status === 'active'
      );
    }
  );

  const isEnabled = hasFeatureFlag === true && sfdcIntegration != null;

  useEffect(() => {
    if (isEnabled) {
      dispatch(getShareVideoAlias(video.id));
    }
  }, [video, dispatch, isEnabled]);

  const showTooltip =
    video.privacy === VIDEO_PRIVACY_OWNER ||
    video.privacy === VIDEO_PRIVACY_WORKSPACE;
  const privacyTooltip =
    'Links must be set to public to enable the Salesforce integration';

  const ActionButton = () => (
    <Button
      hasFullWidth
      variant="neutral"
      onClick={() => showModal()}
      isDisabled={showTooltip}
    >
      {shareVideoAliases.length > 0 ? 'Edit emails' : 'Sync with Salesforce'}
    </Button>
  );

  return (
    <>
      {isEnabled && (
        <div className="mt:large pt:large borderTop">
          <div className={classnames(styles.sfdcContainer)}>
            <Layout alignment="center" gap="small">
              <Layout.Section width={4} className={styles.sfdcIcon}>
                <img src={salesforceIcon} />
              </Layout.Section>
              <Layout.Section>
                <Text variant="title">Salesforce</Text>
              </Layout.Section>
            </Layout>
            <Spacer bottom="xsmall" />
            <Text color="bodyDimmed" size="small">
              Track your video outreach in Salesforce.
            </Text>
            <Spacer bottom="small" />
            <Container
              maxHeight={25}
              className={styles.sfdcScrollableContainer}
            >
              <SalesforceEmailsList />
            </Container>
            <Spacer bottom="small" />
            {showTooltip ? (
              <Tooltip content={privacyTooltip} isInline={false}>
                <ActionButton />
              </Tooltip>
            ) : (
              <ActionButton />
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default SalesforceShare;
